const CardCaptureForm = Vue.component('card-capture-form', {
    template: '#payment-capture-form',

    data() {
        return {
            form: {
                description: {
                    value: "",
                },
                name: {
                    value: "",

                    /** @type {?string} */
                    error: null,
                    validate: () => {
                        if(!this.validators.empty(this.form.name, 'Name')) {
                            return false
                        }

                        if(!this.validators.lettersOnly(this.form.name, 'Name')) {
                            return false
                        }

                        return true
                    }
                },
                cardNumber: {
                    _value: "",

                    set value(v) {
                        const amex = RegExp(/^3[47]\d{0,13}/)

                        if(amex.test(v)) {
                            const regex = /^(\d{0,4})(\d{0,6})(\d{0,5})$/g
                            const onlyNumbers = v.replace(/[^\d]/g, '')

                            this._value = onlyNumbers.replace(regex, (regex, $1, $2, $3) =>
                              [$1, $2, $3].filter(group => !!group).join(' ')
                            )
                        } else {
                            const regex = /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g
                            const onlyNumbers = v.replace(/[^\d]/g, '')

                            this._value = onlyNumbers.replace(regex, (regex, $1, $2, $3, $4) =>
                              [$1, $2, $3, $4].filter(group => !!group).join(' ')
                            )
                        }
                    },

                    get value() {
                        return this._value
                    },

                    /** @type {?string} */
                    error: null,
                    validate: () => {
                        if(!this.validators.empty(this.form.cardNumber, 'Card Number')) {
                            return false
                        }

                        if(!this.validators.digitsOnly(this.form.cardNumber, "Card Number")) {
                            return false
                        }

                        return true
                    }
                },
                expMonth: {
                    value: "",

                    /** @type {?string} */
                    error: null,
                    validate: () => {
                        this.validators.formatMonth(this.form.expMonth)

                        if(!this.validators.empty(this.form.expMonth, 'Expiry month')) {
                            return false
                        }

                        if(!this.validators.digitsOnly(this.form.expMonth, "Expiry month")) {
                            return false
                        }

                        if(!this.validators.month(this.form.expMonth, "Expiry month")) {
                            return false
                        }

                        return true
                    }
                },
                expYear: {
                    value: "",

                    /** @type {?string} */
                    error: null,
                    validate: () => {
                        if(!this.validators.empty(this.form.expYear, 'Expiry year')) {
                            return false
                        }

                        if(!this.validators.digitsOnly(this.form.expYear, "Expiry year")) {
                            return false
                        }

                        return true
                    }
                },
                cvc: {
                    value: "",

                    /** @type {?string} */
                    error: null,
                    validate: () => {
                        if(!this.validators.empty(this.form.cvc, 'CVC')) {
                            return false
                        }

                        if(!this.validators.digitsOnly(this.form.cvc, "CVC")) {
                            return false
                        }

                        return true
                    }
                },
            },

            /**
             * @return {string}
             */
            get cardNumberUnmasked() {
                return this.form.cardNumber.value.replace(/\s/g, '')
            },

            get cardNumberFlipCard() {
                let number = this.cardNumberUnmasked
                let placeholder = ""

                if(this.cardType === 'amex') {
                    if(number.length < 15) {
                        placeholder = "0".repeat(15 - number.length)
                        number = `${number}${placeholder}`
                    }

                    const regex = /^(\d{0,4})(\d{0,6})(\d{0,5})$/g
                    const onlyNumbers = number.replace(/[^\d]/g, '')

                    return onlyNumbers.replace(regex, (regex, $1, $2, $3) =>
                      [$1, $2, $3].filter(group => !!group).join(' ')
                    )
                } else {
                    if(number.length < 16) {
                        placeholder = "0".repeat(16 - number.length)
                        number = `${number}${placeholder}`
                    }

                    const regex = /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g
                    const onlyNumbers = number.replace(/[^\d]/g, '')

                    return onlyNumbers.replace(regex, (regex, $1, $2, $3, $4) =>
                      [$1, $2, $3, $4].filter(group => !!group).join(' ')
                    )
                }
            },

            localValid: false,

            /**
             * @type {?string}
             */
            cardType: null,

            cardBack: false,

            cardMaxLength: 19,

            validators: {
                /**
                 * @param {{value: string, error: ?string, validate: Function}} o
                 * @param {string} fn
                 */
                empty(o, fn) {
                    let state = o.value.length > 0 ? true : false

                    if(!state) {
                        o.error = `${fn} can not be empty.`
                    } else {
                        o.error = null
                    }

                    return state
                },

                /**
                 * @param {{value: string, error: ?string, validate: Function}} o
                 * @param {string} fn
                 */
                lettersOnly(o, fn) {
                    let state = /^[A-Za-z\s]+$/.test(o.value) ? true : false

                    if(!state) {
                        o.error = `${fn} can contain only letters.`
                    } else {
                        o.error = null
                    }

                    return state
                },

                /**
                 * @param {{value: string, error: ?string, validate: Function}} o
                 * @param {string} fn
                 */
                digitsOnly(o, fn) {
                    let state = /^(\s*[0-9]+\s*)+$/.test(o.value) ? true : false

                    if(!state) {
                        o.error = `${fn} can contain only numbers.`
                    } else {
                        o.error = null
                    }

                    return state
                },

                /**
                 * @param {{value: string, error: ?string, validate: Function}} o
                 * @param {string} fn
                 */
                month(o, fn) {
                    const m = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
                    let state = m.includes(o.value) ? true : false

                    if(!state) {
                        o.error = `${fn} is not a valid month. F.e: 02 .`
                    } else {
                        o.error = null
                    }

                    return state
                },

                /**
                 * @param {{value: string, error: ?string, validate: Function}} o
                 */
                formatMonth(o) {
                    let v = Number(o.value)
                    if((v < 10) && (o.value.length < 2) && o.value !== "") {
                        o.value = `0${o.value}`
                    }
                }
            },

            /**
             * Due to the fact that component template is included on the page
             * by hardcoding the id will result in non unique dom elements
             * being rendered in the browser.
             *
             * Bind the id of elemnt instead.
             *
             * @type {string}
             */
            formId: "payment-capture-form-rendered",
            dataSecret: "zJGfwF8Bi7JSL0cxeCIxX8da9Og14ygphy7gdmbwZnLMSkGph7Yuhy"
        }
    },

    methods: {
        /**
         * @return {Promise}
         */
        initForm() {
            return new Promise((resolve, reject) => {
                const form = document.forms[this.formId]
                if(form) {
                    PaymentInfoCapture.initForm(form)
                        .then(
                            r => resolve(),
                            e => reject(`There was a problem while initializing card capture form.`)
                        )
                } else {
                    reject(`Can not initialize payment capture form. Element with id: #${this.formId} does not exists in DOM.`)
                }
            })
        },

        handleForm(e) {
            if(
                this.form.name.validate() &&
                this.form.cardNumber.validate() &&
                this.form.expMonth.validate() &&
                this.form.expYear.validate() &&
                this.form.cvc.validate()
            ) {
                this.localValid = true
            } else {
                this.localValid = false
            }

            e.preventDefault()
        },

        async init(cb = null) {
            if(cb) {
                cb()
            }

            await this.initForm()
            $('[data-bs-toggle="tooltip"]').tooltip()
        },

        detectCardType(v) {
            /**
             * Starts with 4
             */
            const visa = new RegExp(/^4[0-9]{0,}$/)

            /**
             * Starts with:
             * 51 - 55
             * 2221 - 2229
             * 223 - 229
             * 23 - 26
             * 270 or 271
             * 2720
             */
            const mc = RegExp(/^5[1-5][0-9]{0,}|^222[1-9][0-9]{0,}|^22[3-9][0-9]{0,}|^2[3-6][0-9]{0,}|^27[01][0-9]{0,}|^2720[0-9]{0,}$/)

             // starts with 34/37; 15 digits
            const amex = RegExp(/^3[47]\d{0,13}/)

            v = Number(v)

            if(visa.test(v)) {
                this.cardType = 'visa'
                this.cardMaxLength = 19
                return
            }

            if(mc.test(v)) {
                this.cardType = 'mastercard'
                this.cardMaxLength = 19
                return
            }

            if(amex.test(v)) {
                this.cardType = 'amex'
                this.cardMaxLength = 17
                return
            }

            this.cardType = null
        },

        manageExpYear(event) {
            const val = event.target.value

            if (val.length === 1 && val) {
                this.form.expYear.value = `200${val}`
            }

            if (val.length === 2 && val) {
                this.form.expYear.value = `20${val}`
            }
        }
    },

    watch: {
        cardNumberUnmasked(v) {
            this.detectCardType(v)
        },

        cardBack(v) {
            if(v) {
                $(".flip-card").flip(true);
            } else {
                $(".flip-card").flip(false);
            }
        }
    },

    mounted() {
        /**
         * Initialize flip library
         */
        $(".flip-card").flip({
            trigger: 'manual'
        })

        /**
         * Dispatch an event to root instance once this component
         * is mounted. Used to initialize PaymentInfoCapture on
         * checkout page.
         */
        this.$root.$emit('card-capture-form-mounted', 1)
    }
})
